import type { ListBuilderList } from '../../../types';
import { createStandardOrderClientEmbeddedColumns } from '../columns';
import { ORDER_CLIENT_EMBEDDED_REQUIRED_FIELDS } from '../shared';

/**
 * Client Embedded Carts list configuration
 * Draft orders (carts) created today in CRM (embedded in client view)
 */
export const clientEmbeddedCartsList: ListBuilderList = {
	id: 'client-embedded-carts',
	cacheTTL: 600000,
	name: "Today's Carts",
	type: 'default',
	active: true,
	sortOrder: 4,
	requiredFeature: 'order-entry',
	columns: createStandardOrderClientEmbeddedColumns(),
	description: 'Draft orders (carts) created today in CRM',
	defaultSortId: 'column-dates-desc',
	requiredFields: ORDER_CLIENT_EMBEDDED_REQUIRED_FIELDS,
	filterRules: {
		orderDateRange: {
			defaultValue: [
				{
					id: 'today',
					label: 'Today',
					data: {
						startDate: '{{DATE:0d}}',
						endDate: '{{DATE:0d}}',
					},
				},
			],
		},
		orderStatus: {
			defaultValue: [{ id: '1', label: 'Unsubmitted' }],
		},
		orderOrigin: {
			defaultValue: [{ id: '1', label: 'CRM' }],
		},
	},
};
